"use client";

import { useEffect } from "react";
import { requestForToken, onMessageListener } from "../../firebase";

const PushNotificationComponent = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // ✅ Request FCM token and register service worker
    requestForToken();

    // ✅ Listen to foreground messages
    onMessageListener((payload) => {
      // console.log("📨 Message received:", payload);

      if (
        typeof Notification !== "undefined" &&
        Notification.permission === "granted"
      ) {
        const title = payload?.notification?.title || "New Notification";
        const body = payload?.notification?.body || "";

        if (title === "KYC Status Update") {
          // 🔁 Handle KYC status-specific logic here
          // // Example: show raw numeric status
          // new Notification("KYC Status Update", {
          //     body: `Status Code: ${body}`, // body is the numeric code
          // });
          // if (body === "2") {
          //     // KYC approved
          //     console.log("✅ Your KYC is approved.");
          // } else if (body === "3") {
          //     // KYC rejected
          //     console.log("❌ Your KYC is rejected.");
          // } else {
          //     console.log("ℹ️ KYC status updated.");
          // }
        } else {
          // 📨 Show normal notification
          new Notification(title, { body });
        }
      }
    });
  }, []);

  return null;
};

export default PushNotificationComponent;
